import App from '../App'
import gsap from 'gsap'

export default class Background {
  constructor() {
    this.currentColor = 'white'
  }

  updateCurrentRenderer(newRenderer) {
    if (this.sections) this.resetSections()
    this.sections = newRenderer.querySelectorAll('section')
  }

  updateSectionsPosition() {
    if (!this.sections) return

    this.sectionsRect = []
    
    for (let i = 0; i < this.sections.length; i++) {
      this.sectionsRect.push({
        top: this.sections[i].offsetTop,
        height: this.sections[i].offsetHeight
      })
    }
  }

  resize() {
    this.updateSectionsPosition()
    this.updateCurrentColor('white')
  }

  scroll() {
    if (!this.sections || !this.sectionsRect) return

    if (App.currentScroll > 300) {
      const scroll = App.currentScroll + window.innerHeight * 0.8

      for (let i = 0; i < this.sections.length; i++) {
        const section = this.sections[i]
        const sectionsRect = this.sectionsRect[i]

        if (sectionsRect.top <= scroll && sectionsRect.top + sectionsRect.height > scroll && this.currentColor !== section.dataset.color) this.updateCurrentColor(section.dataset.color)
      }
    } else if (App.currentScroll <= 300 && this.currentColor !== 'white') this.updateCurrentColor('white')
  }

  updateCurrentColor(color) {
    if (App.GPU.tier !== 'GPU_DESKTOP_TIER_0' && App.plane) {
      gsap.to(App.plane.material.uniforms.u_background, {
        value: color === 'black' ? 0 : 1,
        duration: 1,
        ease: 'power2.out'
      })
    }

    document.body.dataset.color = color
    this.currentColor = color
  }

  resetSections() {
    this.sections = null
    this.sectionsRect = null
    document.body.dataset.color = null
  }
}



// WEBPACK FOOTER //
// ./scripts/util/Background.js